import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { Box, Container, } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'
import IntegrationTab from './settings/component/intigrationTab';
import { getOnlineInfo, updateOnlineInfo } from '../hooks/apiHandler';
import { useAuth } from '../hooks/useAuth';


export const Online = () => {
    const [editMode, setEditMode] = useState(false);
    var storeID = useRef(JSON.parse(window.localStorage.getItem('ds')));
    const { Logout } = useAuth();

    const [onlineInfo, setOnlineInfo] = useState({
        storeID: storeID.current,
        title: '',
        description: '',
        favicon: '',
        logo: '',
        bHeading: '',
        bSubTitle: '',
        bParaggraph: '',
        bImage: '',
        socialLinks: {
            facebook: '',
            instagram: '',
            youtube: '',
            twitter: '',
            linkedin: ''
        }
    });

    async function onlineInfoFetcher() {
        var response = await getOnlineInfo({ storeID: onlineInfo.storeID },Logout);
        if (response.code === 0) {
            // this will try to set data if any data found
            setOnlineInfo(await response.data);
        }
    }

    useEffect(() => {
        // this is to call server for any initial Data....
        onlineInfoFetcher()
        return () => {
            // this is same as component unmount of leaving the page..
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Container maxWidth={false} sx={{ width: '100%',position:'relative' }}>
            <h2>Integration Guide</h2>
            <IntegrationTab />
            <Box>
                <Grid container
                    justifyContent="space-between"
                    alignItems="center" >
                    <Grid item xs={12} md={6}>
                        <h4> Online Info:</h4 >
                    </Grid>
                    <Grid item xs={12} md="auto">
                        {(editMode) ? (<Button
                            onClick={async () => {
                                setEditMode(false);
                                onlineInfo();
                            }}
                        >Cancel</Button>) : ''}

                        {(!editMode) ?
                            (<Button
                                variant="outlined" onClick={() => { setEditMode(true) }}>Edit</Button>) : ''}


                        {(editMode) ? (<Button variant="contained"
                            onClick={async () => {
                                // set loading to true...
                                console.log('time to update Store information...');
                                var respSaveData = await updateOnlineInfo(onlineInfo,Logout);
                                if (respSaveData.code === 0) {
                                    console.log('Update with New response');
                                    console.log(respSaveData);
                                }
                                setEditMode(false);
                            }}
                        >Save</Button>) : ''}

                    </Grid>
                </Grid>
                <hr />

                <Grid container alignItems="center" columns={4}>
                    <Grid item xs={12} md={1} >
                        <Typography>Title  : &nbsp;</Typography>

                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="onlineTitle"
                                type='text'
                                placeholder="Title"
                                required
                                size="small"
                                value={onlineInfo.title}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, title: e.target.value })}
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Description : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="onlineDescription"
                                value={onlineInfo.description}
                                type='text'
                                placeholder="Store Description"
                                required
                                size="small"
                                disabled={!editMode}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, description: e.target.value })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Favicon : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                id="favicon"
                                value=''
                                type='file'
                                required
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Logo : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                id="logo"
                                value=''
                                type='file'
                                required
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>

                </Grid>
                <Grid container
                    justifyContent="space-between"
                    alignItems="center" >
                    <Grid item xs={12} md={6}>
                        <h4> Home Page:</h4 >
                    </Grid>
                </Grid>
                <hr />
                <Grid container alignItems="center" columns={4}>
                    <Grid item xs={12} md={1} >
                        <Typography>Banner Heading : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="heading"
                                value={onlineInfo.bHeading}
                                type='text'
                                placeholder="Banner heading"
                                required
                                size="small"
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, bHeading: e.target.value })}
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Banner Subheading : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="subheading"
                                value={onlineInfo.bSubTitle}
                                type='text'
                                placeholder="Banner Sub Heading"
                                required
                                size="small"
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, bSubTitle: e.target.value })}
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Banner Paragraph : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="paragraph"
                                value={onlineInfo.bParaggraph}
                                type='text'
                                placeholder="Banner Paragraph"
                                required
                                size="small"
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, bParaggraph: e.target.value })}
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Banner Image : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                id="bannerImage"
                                value={onlineInfo.bImage}
                                type='file'
                                required
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container
                    justifyContent="space-between"
                    alignItems="center" >
                    <Grid item xs={12} md={6}>
                        <h4>Contact info and Social Link:</h4 >
                    </Grid>
                </Grid>
                <hr />
                <Grid container alignItems="center" columns={4}>
                    {/* <Grid item xs={12} md={1} >
                        <Typography>Contact : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="heading"
                                value={}
                                type='number'
                                placeholder="Your Phone No."
                                required
                                size="small"
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Email : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="heading"
                                value=''
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid> */}
                    <Grid item xs={12} md={1} >
                        <Typography>Facebook : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="Facebook"
                                value={onlineInfo.socialLinks.facebook}
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, facebook: e.target.value })}
                                disabled={!editMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Instagram : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="instagram"
                                value={onlineInfo.socialLinks.instagram}
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                disabled={!editMode}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, instagram: e.target.value })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Youtube : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="youtube"
                                value={onlineInfo.socialLinks.youtube}
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                disabled={!editMode}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, youtube: e.target.value })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Twitter : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="twitter"
                                value={onlineInfo.socialLinks.twitter}
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                disabled={!editMode}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, twitter: e.target.value })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={1} >
                        <Typography>Linkedin : &nbsp;</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, width: { xs: '100%', md: '60ch' } }} variant="filled">
                            <TextField
                                variant="filled"
                                id="linkedin"
                                value={onlineInfo.socialLinks.linkedin}
                                type='email'
                                placeholder="Your Email"
                                required
                                size="small"
                                disabled={!editMode}
                                onChange={(e) => setOnlineInfo({ ...onlineInfo, linkedin: e.target.value })}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>
             <Box sx={{position:'absolute', width:'100%',height:'100%',background:'#ffffffe0',left:0,top:0,display:"flex",justifyContent:'center',alignItems:'center'}} >
                <Typography sx={{fontSize:'34px'}}> Coming Soon</Typography>
            </Box>
        </Container>
    )
}

